<template>
  <section class="pt-2">
    <!-- User Message -->
    <div v-if="message.sender_type === 'user'">
      <template v-if="message.type === 'text'">
        <text-message :message="message"/>
      </template>
      <template v-if="message.type === 'image'">
        <image-message :message="message"/>
      </template>
      <div class="clearfix"></div>
    </div>

    <!-- Bot Message -->
    <div v-else>
      <img
        src="/static/img/logo-chat-booking.png"
        class="float-left align-items-center chat-profile"/>

      <template v-if="message.type === 'text'">
        <text-message :message="message"/>
      </template>
      <template v-if="message.type === 'image'">
        <image-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'template'">
        <template-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'register'">
        <register-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'otp'">
        <otp-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'create-user-place'">
        <user-place-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'select-date-time'">
        <date-time-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'buttons'">
        <buttons-message :message="message"/>
      </template>
      <template v-else-if="(message.type === 'booking-summary' || message.type === 'booking-summary-incomplete')">
        <booking-summary-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'payment-method'">
        <payment-method-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'bank-transfer'">
        <bank-transfer-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'change-payment-bank-transfer'">
        <change-payment-bank-transfer-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'promptpay'">
        <promptpay-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'credit-card'">
        <credit-card-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'order-detail'">
        <order-detail-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'service-request-detail'">
        <service-request-detail-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'additional-remark'">
        <additional-remark-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'create-service-request-first'">
        <service-request-first-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'create-service-request-second'">
        <service-request-second-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'service-items'">
        <service-item-message :message="message"/>
      </template>
      <template v-else-if="message.type === 'has-ironing-board'" >
        <has-ironing-board-message :message="message"/>
      </template>
      <div class="clearfix"></div>
    </div>
    <!-- Quick Reply -->
    <quick-reply :message="message"/>
    <!-- Carousel -->
    <carousel :message="message"/>
  </section>
</template>

<script>
  import AdditionalRemarkMessage from './components/AdditionalRemarkMessage'
  import BankTransferMessage from './components/BankTransferMessage'
  import BookingSummaryMessage from './components/BookingSummaryMessage'
  import ButtonsMessage from './components/ButtonsMessage'
  import Carousel from './components/Carousel'
  import ChangePaymentBankTransferMessage from './components/ChangePaymentBankTransferMessage'
  import CreditCardMessage from './components/CreditCardMessage'
  import DateTimeMessage from './components/DateTimeMessage'
  import HasIroningBoardMessage from './components/HasIroningBoardMessage'
  import ImageMessage from './components/ImageMessage'
  import OrderDetailMessage from './components/OrderDetailMessage'
  import OtpMessage from './components/OTPMessage'
  import PaymentMethodMessage from './components/PaymentMethodMessage'
  import PromptpayMessage from './components/PromptpayMessage'
  import QuickReply from './components/QuickReply'
  import RegisterMessage from './components/RegisterMessage'
  import ServiceItemMessage from './components/ServiceItemMessage'
  import ServiceRequestFirstMessage from './components/ServiceRequestFirstMessage'
  import ServiceRequestSecondMessage from './components/ServiceRequestSecondMessage'
  import ServiceRequestDetailMessage from './components/ServiceRequestDetailMessage'
  import TemplateMessage from './components/TemplateMessage'
  import TextMessage from './components/TextMessage'
  import UserPlaceMessage from './components/UserPlaceMessage'

  export default {
    props: {
      message: Object
    },
    components: {
      AdditionalRemarkMessage,
      BankTransferMessage,
      BookingSummaryMessage,
      ButtonsMessage,
      Carousel,
      ChangePaymentBankTransferMessage,
      CreditCardMessage,
      DateTimeMessage,
      HasIroningBoardMessage,
      ImageMessage,
      OrderDetailMessage,
      OtpMessage,
      PaymentMethodMessage,
      PromptpayMessage,
      QuickReply,
      RegisterMessage,
      ServiceItemMessage,
      ServiceRequestFirstMessage,
      ServiceRequestSecondMessage,
      ServiceRequestDetailMessage,
      TemplateMessage,
      TextMessage,
      UserPlaceMessage
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/Message.vue